import { format } from "date-fns";

export const formatDateWithoutTimezone = (date: Date | null | undefined) => (date ? format(date, "yyyy-MM-dd") : null);